import React from "react";
// icons
import SavedProductIcon from "@frameworks/shared-library/assets/images/features/Markets/Pms/product.svg";
//shared-library
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/draft.scss";
var DraftAlready = function () {
    //
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "draft-already-container d-flex flex-column justify-content-center align-items-center h-100" },
            React.createElement("img", { src: SavedProductIcon, alt: "SavedProductIcon" }),
            React.createElement("div", { className: "draft-already-inner" },
                React.createElement("h6", { className: "DMSansMedium_20_500" }, "Draft Already Exists!"),
                React.createElement("p", { className: "DMSans_13_400" }, "A draft with the same name and value already exists. Would you like to continue editing the draft?")))));
};
export default DraftAlready;
